import React, { Fragment } from "react";
import { Text, View, StyleSheet } from "@react-pdf/renderer";

const styles = StyleSheet.create({
  titleContainer: {
    flexDirection: "row",
    marginTop: 5,
    marginBottom: 5,
    // paddingHorizontal: 20,
    // paddingVertical: 10,
  },
  tableLeft: {
    width: "65%",
    marginRight: 5,
  },
  tableRight: {
    display: "table",
    width: "35%",
    borderStyle: "solid",
    // borderWidth: 1,
    borderColor: "#e5e7eb", // Tailwind border-gray-300
    marginLeft: 5,
  },
  tableRowRight: {
    flexDirection: "row",
  },
  tableColRightLeft: {
    width: "50%",
    backgroundColor: "#f3f4f6", // Tailwind bg-gray-100
    // borderRightWidth: 1,
    borderColor: "#e5e7eb",
  },
  tableColRight: {
    width: "50%",
    // borderLeftWidth: 1,
    borderColor: "#e5e7eb",
  },
  tableCellRight: {
    fontSize: 9,
    textAlign: "center",
    paddingTop: 4,
    paddingBottom: 4,
    paddingLeft: 2,
    paddingRight: 2,
  },
});

const TotalVoucher = ({ invoice }) => {
  var invoice1 = JSON.stringify(invoice);
  var invoice2 = JSON.parse(invoice1);
  var invoice3 = JSON.parse(invoice2);

  return (
    <Fragment>
      <View style={styles.titleContainer}>
        <View style={styles.tableLeft}></View>

        <View style={styles.tableRight}>
          <View style={styles.tableRowRight}>
            <View style={styles.tableColRightLeft}>
              <Text style={styles.tableCellRight}>Total</Text>
            </View>
            <View style={styles.tableColRight}>
              <Text style={styles.tableCellRight}>
                <b>&#8364; {invoice3.booking_amount.toFixed(2)}</b>
              </Text>
            </View>
          </View>
        </View>
      </View>
    </Fragment>
  );
};

export default TotalVoucher;
